import Vue from 'vue';
import Vuex from 'vuex';

import registrierungModule from '@/store/modules/registrierung';
import addressModule from '@/store/modules/adresse';
import productModule from '@/store/modules/produkt';
import userModule from '@/store/modules/user';
import unterlagenListeModule from '@/store/modules/gekaufte-produkte/listen/states/unterlagen';
import gutachtenspeicherListModule from '@/store/modules/gekaufte-produkte/listen/states/gutachtenspeicher';
import kasseModule from '@/store/modules/kasse';
import objektbesichtigung from '@/store/modules/objektbesichtigung';
import gutachten from '@/store/modules/gutachten';
import kaufpreisaufteilung from '@/store/modules/kaufpreisaufteilung';
import gekaufteProdukte from '@/store/modules/gekaufte-produkte';
import metadataLinks from '@/js/metadataLinks';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    pageTitle: undefined,
    homeButton: false,
    loading: false,
    pageSize: window.innerWidth,
    alert: {
      type: 'error',
      show: false,
      message: undefined,
    },
    snackbar: {
      show: false,
      message: undefined,
    },
    links: {
      nutzungsbedingungen: metadataLinks.nutzungsbedingungen,
      datenschutzerklaerung: metadataLinks.datenschutzerklaerung,
      products: metadataLinks.products,
    },
  },
  mutations: {
    SET_PAGE_TITLE(state, title) {
      state.pageTitle = title;
    },
    SET_HOME_BUTTON(state, bool) {
      state.homeButton = bool;
    },
    SET_ALERT(state, alert) {
      state.alert = {
        show: true,
        type: alert.type,
        message: alert.message,
      };
    },
    DELETE_ALERT(state) {
      state.alert = {
        show: false,
        type: 'error',
        message: undefined,
      };
    },
    SET_SNACKBAR(state, snackbar) {
      state.snackbar = {
        show: true,
        message: snackbar.message,
      };
    },
    DELETE_SNACKBAR(state) {
      state.snackbar = {
        show: false,
        message: undefined,
      };
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_PAGESIZE(state, size) {
      state.pageSize = size;
    },
  },
  actions: {
    resetModules({dispatch, commit}) {
      commit('SET_PAGE_TITLE', undefined);
      commit('SET_HOME_BUTTON', false);
      commit('DELETE_ALERT');
      commit('DELETE_SNACKBAR');
      dispatch('address/clearAddress');
      dispatch('product/reset');
      dispatch('user/reset');
      dispatch('kasse/reset');
      dispatch('gutachten/reset');
      dispatch('objektbesichtigung/reset');
      dispatch('kaufpreisaufteilung/reset');
    },
    setPageTitle({commit}, title) {
      commit('SET_PAGE_TITLE', title);
    },
    setHomeButton({commit}, bool) {
      commit('SET_HOME_BUTTON', bool);
    },
    setAlert({commit}, alert) {
      commit('SET_ALERT', {
        ...alert,
        show: true,
      });
    },
    clearAlert({commit}) {
      commit('DELETE_ALERT');
    },
    setSnackbar({commit}, snackbar) {
      commit('SET_SNACKBAR', {
        ...snackbar,
        show: true,
      });
    },
    clearSnackbar({commit}) {
      commit('DELETE_SNACKBAR');
    },
    setLoading({commit}, loading) {
      commit('SET_LOADING', loading);
    },
    setPageSize({commit}) {
      commit('SET_PAGESIZE', window.innerWidth);
    },
  },
  getters: {
    pageTitle: state => state.pageTitle,
    alert: state => state.alert,
    snackbar: state => state.snackbar,
    loading: state => state.loading,
    pagesize: state => state.pageSize,
    homeButton: state => state.homeButton,
    links: state => state.links,
  },
  modules: {
    registrierung: registrierungModule,
    address: addressModule,
    product: productModule,
    user: userModule,
    unterlagen: unterlagenListeModule,
    gutachtenspeicher: gutachtenspeicherListModule,
    kasse: kasseModule,
    gutachten,
    objektbesichtigung,
    kaufpreisaufteilung,
    gekaufteProdukte
  },
});

export default store;
